const basePath = 'insight_global_api';

export const HPI_SIMILAR_LISTING = `/api/listing/portal/listing/v1/search`;

export const CLAIM_PROPERTY = `${basePath}/property/claim/commit/v1.0`;
export const CLAIM_PROPERTY_LIST = `${basePath}/property/claim/list/v1.0`;

export const AVM_PREVIEW_V2 = `${basePath}/preview/public/property/v1.0`;
export const AVM_VALUATION = `${basePath}/valuation/public/property/v1.0`;
export const AVM_MARKET_STAT = `${basePath}/MarketStats/avmProperty/v1.0`;

export const MARKET_INSIGHT_LANDING_V2 = `${basePath}/hierarchicalLocation/city/HPILanding`;

export const MARKET_STAT_V2 = `${basePath}/propertyMarketStatsAndTrends/v1.1`;
export const HIERARCHICAL = `/api/location/portal/boundary/v1/get-boundary`;
export const HIERARCHICAL_V2 = `${basePath}/hierarchicalLocation/MarketStats/v2`;

export const TRENDS_CONFIG = `${basePath}/trends/config/v1.0`;
export const TRENDS = `${basePath}/trends/v1.0`;
